import React, { forwardRef } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}
export const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(({
  searchQuery,
  onSearchChange
}, ref) => {
  return <div className="relative max-w-2xl mx-auto mb-6 sm:mb-8" data-id="element-185">
        <div className="relative" data-id="element-186">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-187" />
          <input ref={ref} type="text" value={searchQuery} onChange={e => onSearchChange(e.target.value)} placeholder="Search roadmap..." className="w-full pl-12 pr-12 py-3 sm:py-4 bg-white dark:bg-[#1A2332] border-2 border-gray-200 dark:border-[#2A3F5F] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7FE5A8] focus:border-transparent transition-all shadow-md text-[#1A2332] dark:text-white placeholder-gray-400 dark:placeholder-gray-500" data-id="element-188" />
          {searchQuery && <button onClick={() => onSearchChange('')} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors" data-id="element-189">
              <XIcon className="h-5 w-5" data-id="element-190" />
            </button>}
        </div>
      </div>;
});
SearchBar.displayName = 'SearchBar';